export const faqItems = [
  {
    question: "猫咪社区是免费的吗？",
    answer: "是的，猫咪社区完全免费！我们致力于为所有爱猫人士打造一个开放、温暖的交流平台。所有文章、图片和社区功能均不收取任何费用。",
  },
  {
    question: "如何在猫咪社区发布文章？",
    answer: "您可以在注册账号后，点击页面右上角的「发布」按钮进入文章编辑页面。支持富文本编辑和图片上传，写好后提交审核即可。审核通常在工作日24小时内完成。",
  },
  {
    question: "领养信息如何发布和验证？",
    answer: "发布领养信息需要提供猫咪的基本情况、健康状态和联系方式。我们的志愿者团队会对信息进行初步核实，但领养双方仍需自行沟通确认细节，确保猫咪能得到妥善的照顾。",
  },
  {
    question: "社区中的健康建议可以替代兽医吗？",
    answer: "不可以。猫咪社区中的所有健康相关内容仅供参考和交流，不能替代专业兽医的诊断和治疗。如果您的猫咪出现健康问题，请务必及时带它去正规宠物医院就诊。",
  },
  {
    question: "如何联系猫咪社区的管理团队？",
    answer: "您可以通过关于我们页面的联系方式找到我们，包括邮箱、微信公众号和官方微博。我们非常乐意听取您的建议和反馈！",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "铲屎官小美",
    role: "资深会员 · 养猫5年",
    content: "猫咪社区是我每天必刷的网站！从新手养猫到现在的老司机，几乎所有养猫知识都是在这里学的。社区的铲屎官们都特别热心，有问题发帖马上有人回复。",
  },
  {
    id: 2,
    name: "医生老张",
    role: "执业兽医师 · 社区健康顾问",
    content: "作为一名兽医，我很高兴看到猫咪社区在科普正确的养猫知识方面做出的努力。这里的问答质量很高，铲屎官们的科学养猫意识也越来越强了。",
  },
  {
    id: 3,
    name: "多猫家庭阿强",
    role: "活跃用户 · 养猫8年",
    content: "家里五只猫，全是领养来的。猫咪社区的领养板块做得特别好，我家的老二和老四就是在这里找到的。真的改变了很多流浪猫的命运。",
  },
];

export const brandStory = `猫咪社区成立于2020年，由一群热爱猫咪的资深铲屎官共同创立。我们的初心很简单：打造一个纯粹的、高质量的猫咪爱好者交流平台，让每一位爱猫人都能在这里找到归属感。

成立至今，猫咪社区已发展成为拥有超过32万注册会员的活跃社区平台。我们坚持内容质量第一的原则，汇聚了来自全国各地的兽医专家、资深猫奴和猫咪行为学研究者，为铲屎官们提供科学、实用的养猫知识和经验分享。

在猫咪社区，我们相信每一只猫咪都值得被温柔对待。通过知识普及、领养倡导和社区互助，我们希望能为改善国内猫咪的生存环境贡献一份力量。`;